import { render } from "./PortfolioSection.vue?vue&type=template&id=7f8aa86e"
import script from "./PortfolioSection.vue?vue&type=script&lang=js"
export * from "./PortfolioSection.vue?vue&type=script&lang=js"

import "./PortfolioSection.vue?vue&type=style&index=0&id=7f8aa86e&lang=css"

import exportComponent from "C:\\Users\\ynyan\\Desktop\\官网\\YNOfficialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__